import React from 'react';
import styles from './StudyCard.module.scss';
import { useStudyCard } from './hooks/useStudyCard';
import { StudyCardProps } from './types';

export const StudyCard: React.FC<StudyCardProps> = ({ study, onViewCertificate, isOpen, onToggle }) => {
    const {
        t,
        formattedDateRange,
        getBadgeClass,
        handleCertificateClick
    } = useStudyCard(study, onViewCertificate, styles);

    return (
        <details className={styles['study-card']} open={isOpen}>
            <summary 
                className={styles['study-summary']} 
                onClick={(e) => {
                    e.preventDefault();
                    onToggle?.();
                }}
            >
                <span className={styles['study-heading']}>
                    <strong>{study.name}</strong>
                    <span>{study.institute}</span>
                </span>
                <span className={styles['study-plus']} aria-hidden="true">＋</span>
            </summary>
            
            <div className={styles['study-content']}>
                {formattedDateRange && (
                    <div className={styles['study-meta']}>
                        {formattedDateRange}
                    </div>
                )}
                
                <div className={styles['study-actions']}>
                    {study.type && (
                        <span className={styles['study-type']}>
                            {study.type.label || study.type.code}
                        </span>
                    )}
                    
                    <div className={styles['study-footer']}>
                        {study.specialty && (
                            <span className={getBadgeClass(study.specialty.dimension?.name.toLowerCase())}>
                                {study.specialty.name}
                            </span>
                        )}

                        {study.url_certificate && (
                            <button
                                type="button"
                                className={styles['study-card__action']}
                                onClick={handleCertificateClick}
                            >
                                {t('landing.TabsComponent.viewCertificate', 'Ver Certificado')}
                                <span className={styles['study-card__arrow']}>→</span>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </details>
    );
};